import React from 'react';
import { Lock, CreditCard, ShieldCheck } from 'lucide-react';
export function Footer() {
  return <footer className="bg-zinc-950 border-t border-zinc-900 py-12 pb-24 md:pb-12" data-id="element-70">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-71">
        <div className="grid md:grid-cols-3 gap-8 items-center md:items-start" data-id="element-72">
          {/* Brand */}
          <div className="text-center md:text-left" data-id="element-73">
            <span className="text-white font-bold text-xl tracking-tight block mb-2" data-id="element-74">
              Sistema iPhone Ads
            </span>
            <p className="text-zinc-500 text-sm" data-id="element-75">
              Estrategias de publicidad para tiendas de iPhone.
            </p>
          </div>

          {/* Links Placeholder */}
          <div className="flex flex-col items-center md:items-start gap-3 text-sm text-zinc-400" data-id="element-76">
            <a href="#" className="hover:text-white transition-colors" data-id="element-77">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-78">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-79">
              Política de Reembolsos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-80">
              Contacto
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-col items-center md:items-end gap-4" data-id="element-81">
            <div className="flex gap-4 text-zinc-500" data-id="element-82">
              <Lock className="w-6 h-6" data-id="element-83" />
              <CreditCard className="w-6 h-6" data-id="element-84" />
              <ShieldCheck className="w-6 h-6" data-id="element-85" />
            </div>
            <p className="text-xs text-zinc-600" data-id="element-86">
              Pagos procesados de forma segura.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-zinc-900 text-center text-xs text-zinc-600" data-id="element-87">
          &copy; {new Date().getFullYear()} Sistema iPhone Ads. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}